// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"fd4d37dd","225":"7b1c871d","248":"0e57cfdd","461":"d0656ce7","813":"03da8861","839":"08e20665","961":"968f3ec7"}[chunkId] + ".chunk.css";
};